import type { ComponentProps } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeCrowdinIframeContext } from '../lib/crowdin-iframe-context';
import { readPageProps } from '../lib/page-props';
import { MainPage } from '../pages/MainPage';

initializeCrowdinIframeContext();

const props = readPageProps<ComponentProps<typeof MainPage>>();

createRoot(document.getElementById('root')!).render(<MainPage {...props} />);
